import { render, staticRenderFns } from "./WPList.vue?vue&type=template&id=4822609c"
import script from "./WPList.vue?vue&type=script&lang=ts"
export * from "./WPList.vue?vue&type=script&lang=ts"
import style0 from "./WPList.vue?vue&type=style&index=0&id=4822609c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports